<template>
  <div class="detail">
    <div class="card-box">
      <div class="title">
        <span>{{ data.report?.inspectItem }}</span>
      </div>
      <div class="row">
        <span>报告单号：</span>
        <span>{{ bgdh }}</span>
      </div>
      <div class="row">
        <span>报告类型：</span>
        <span>{{ data.report?.inspectType }}</span>
      </div>
      <div class="row">
        <div class="left">
          <span>姓名：</span>
          <span>{{ data.report?.patName }}</span>
        </div>
        <div>
          <span>性别：</span>
          <span>{{ data.report?.sex }}</span>
        </div>
      </div>
      <div class="row">
        <div class="left">
          <span>年龄：</span>
          <span>{{ data.report?.age }}</span>
        </div>
        <div>
          <span>科室：</span>
          <span>{{ data.report?.applyDeptName }}</span>
        </div>
      </div>
      <!-- <div class="row">
        <span>就诊卡号：</span>
        <span>{{ data.jzkh }}</span>
      </div> -->
      <div class="row">
        <span>样本种类：</span>
        <span>{{ data.report?.sampleName }}</span>
      </div>
      <div class="row">
        <span>临床诊断：</span>
        <span>{{ data.report?.diagnosisName }}</span>
      </div>
      <div class="row">
        <span>采样日期：</span>
        <span>{{ data.report?.collectTime }}</span>
      </div>
      <!-- <div class="row">
        <span>发布日期：</span>
        <span />
      </div> -->
      <div class="row">
        <div class="more" @click="routeTo()">
          查看更多
        </div>
      </div>
    </div>
    <div class="card-box">
      <div class="title">
        检验结论
      </div>
      <table width="100%">
        <tbody>
          <tr>
            <th>{{ headObj.th1 }}</th>
            <th>{{ headObj.th2 }}</th>
            <th>{{ headObj.th3 }}</th>
          </tr>
          <tr v-for="(item, index) in data.result" :key="index">
            <td>{{ item.indexName }}<br>{{ item.unit }}</td>
            <td>
              <span :class="[item.resultPrompt === '↓' ? 'down' : '', item.resultPrompt === '↑' ? 'up' : '']">{{ item.result }}&nbsp;{{ item.resultPrompt }}</span>
              <!-- <span :class="[item.resultPrompt === '1' ? 'down' : '', item.resultPrompt === '2' ? 'up' : '']">{{ item.result }}&nbsp;{{ item.resultPrompt === '1' ? '↓' : item.resultPrompt === '2' ? '↑' : '' }}</span> -->
            </td>
            <td>{{ item.referRange }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>
<script>

import {patientModel} from "../../../api/patient"

export default {
  name: 'CheckoutDetail',
  data() {
    return {
      data:{},
      bgdh:this.$route.query.bgdh,
      patId:this.$route.query.patId,
      headObj:{
        th1:'项目/单位',
        th2:'结果',
        th3: '参考值'
      }
    }
  },
  mounted(){
    this.loadData()
  },
  
  methods:{
    routeTo(){
      this.$router.push('/checkoutmore?patId='+this.patId+'&bgdh='+this.bgdh)
    },
    loadData(){
      let params={
        patientId: this.$route.query.patId ||'',
        inspectionNo: this.$route.query.bgdh ||''
        // patxm: this.$route.query.patxm ||'',
        // zjh: this.$route.query.zjh ||''
      }
      patientModel.inspectionReportDetail(params).then(res=>{
        this.data = res.data
      })
    }
  }
}
</script>
<style scoped lang='less'>
@import "../../../assets/styles/variable.less";
span{
  &.up {
    color: #ff0000;
  }
  &.down {
    color: #0000ff;
  }
}
.detail {
    padding: 32px;

    .card-box {
        width: 100%;
        background: #FFFFFF;
        border-radius: 12px;
        margin-bottom: 24px;
        padding: 32px;
        box-sizing: border-box;

        table th {
            height: 68px;
            min-width: 140px;
            vertical-align: middle;
            border: 1px solid #DDDDDD;
            position: relative;
            text-align: center;
            color: #3D3D3D;
            font-size: 24px;
            background-color: #FFFFFF;
        }

        table td{
            padding: 40px 10px;
            text-align: center;
            color: #333333;
            font-size: 24px;
            border: 1px solid #DDDDDD;
            background-color: #FFFFFF;
        }

        .title {
            font-size: 32px;
            font-weight: bold;
            color: #3D3D3D;
            line-height: 45px;
            margin-bottom: 32px;
        }
        
        .row {
            display: flex;
            line-height: 40px;
            font-size: 28px;
            margin-bottom: 24px;
            color: #666666;

            .left {
                text-align: left;
                width: 325px;
            }

            .more {
                width: 622px;
                height: 48px;
                border-radius: 24px;
                border: 1px solid #3A8AE5;
                text-align: center;
                color: #3A8AE5;
                line-height: 50px;
                font-size: 24px;
            }
        }
    }
}
</style>
